import { IonItem, IonLabel, IonList, IonListHeader, IonRadio, IonRadioGroup, IonSelectOption, IonSpinner, RadioGroupCustomEvent } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { debug } from "../../App";
import InputFactory from "../Factories/Input/InputFactory";

export default function RadioGroup(props: any) {
  const [currentValue, setCurrentValue] = useState(props.value || props.default);
  const { options, type, value, label, ...disabledFieldProps } = props;
  const disabledValue = props.disabled && options[value] ? options[value] : "-";

  function handleChange(event: RadioGroupCustomEvent) {
    if (event.detail.value !== currentValue) {
      debug("Handling change on radio group", event);
      setCurrentValue(event.detail.value);
    }
  }

  useEffect(() => {
    const ionEvent = new CustomEvent("ionChange", {
      detail: {
        name: props.name,
        value: currentValue,
      },
    });
    props.onIonChange(ionEvent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentValue]);

  return props.disabled ? (
    <InputFactory type="text" value={disabledValue} className="collapse-form__field-value" placeholder="―" disabled {...disabledFieldProps} />
  ) : (
    <IonList lines="none">
      {label && <IonLabel>{label}</IonLabel>}
      <IonRadioGroup value={props.value} onIonChange={handleChange}>
        {props.placeholder && (
          <IonListHeader className="input__input-radio-header">
            <IonLabel>{props.placeholder}</IonLabel>
          </IonListHeader>
        )}
        {options && Object.keys(options).length ? (
          Object.keys(options).map((option: any, key) => (
            <IonItem className="input__input-radio-item" key={"radiogroup-" + props.name + "-" + key}>
              <IonLabel>{options[option]}</IonLabel>
              <IonRadio slot="start" value={option} />
            </IonItem>
          ))
        ) : (
          <IonSelectOption>
            <IonSpinner name="dots" />
          </IonSelectOption>
        )}
      </IonRadioGroup>
    </IonList>
  );
}
